import { useState } from 'react';
import axios from 'axios';
import CONFIG from '../../constanta/config';
import Cookies from 'js-cookie';

export default function SurveyFormDay1(props) {
  const [answers, setAnswers] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);


  const validate = () => {
    let newErrors = {};
    let firstErrorId = null; // 🔥 simpan error pertama

    questions.forEach((q) => {
      // RADIO / TEXTAREA / RATING
      if (q.type === "radio" || q.type === "textarea" || q.type === "rating") {
        if (!answers[q.id]) {
          newErrors[q.id] = true;

          if (!firstErrorId) {
            firstErrorId = q.id;
          }
        }
      }

      // MATRIX
      if (q.type === "rating-matrix") {
        q.items.forEach((item) => {
          if (!answers[item.id]) {
            newErrors[item.id] = true;

            if (!firstErrorId) {
              firstErrorId = item.id; // 🔥 ambil item pertama yg error
            }
          }
        });
      }
    });

    setErrors(newErrors);

    // 🚀 SCROLL KE ERROR PERTAMA
    if (firstErrorId) {
      setTimeout(() => {
        const el = document.getElementById(`question-${firstErrorId}`);
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
    }

    return Object.keys(newErrors).length === 0;
  };

  const moveUp = (qId, index) => {
    setQuestions(prev =>
      prev.map(q => {
        if (q.id !== qId) return q;

        const newItems = [...q.items];
        [newItems[index - 1], newItems[index]] =
          [newItems[index], newItems[index - 1]];

        return { ...q, items: newItems };
      })
    );
  };

  const moveDown = (qId, index) => {
    setQuestions(prev =>
      prev.map(q => {
        if (q.id !== qId) return q;

        const newItems = [...q.items];
        [newItems[index + 1], newItems[index]] =
          [newItems[index], newItems[index + 1]];

        return { ...q, items: newItems };
      })
    );
  };

  const [questions, setQuestions] = useState([

    {
      no: '1',
      id: '1',
      question: 'What is your age range?',
      type: 'radio',
      options: ['18-24', '25-29', '30-34', '35-39', '40-44', '45 and over']
    },
    {
      no: '2',
      id: '2',
      question: 'Which country are you located?',
      type: 'radio',
      options: [
        'Anguilla',
        'Guyana',
        'Antigua and Barbuda',
        'Haiti',
        'Aruba',
        'Jamaica',
        'Bahamas',
        'Saba',
        'Barbados',
        'Martinique',
        'Belize',
        'Montserrat',
        'Bermuda',
        'Saint Kitts and Nevis',
        'Bonaire',
        'Saint Lucia',
        'St. Eustatius',
        'Sint Maarten',
        'British Virgin Islands',
        'Saint Vincent and the Grenadines',
        'Cayman Islands',
        'Suriname',
        'Curacao',
        'Trinidad and Tobago',
        'Dominica',
        'Turks and Caicos',
        'Grenada',
        'Other'
      ],
      hasOther: true
    },
    {
      no: '3',
      id: '3',
      question: 'Type of Institution',
      type: 'radio',
      options: [
        'Academia',
        'Public Sector',
        'Private Sector',
        'Government',
        'Non-Governmental Organisation',
        'Inter-Governmental Organisation',
        'Civil Society Organisation',
        'Other'
      ],
      hasOther: true
    },
    {
      no: '4',
      id: '4',
      question: 'Do you operate (work/study) in a health-related field?',
      type: 'radio',
      options: ['Yes', 'No']
    },
    {
      no: '5',
      id: '5',
      question:
        'Please rate the following aspects of the Oral Presentation Sessions:',
      type: 'rating-matrix',
      items: [
        { id: '6', label: 'Scientific content' },
        { id: '7', label: 'Clarity of presentation' },
        { id: '8', label: 'Quality of slides' },
        { id: '9', label: 'Discussion' },
        { id: '10', label: 'Time management' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },
    {
      no: '6',
      id: '11',
      question:
        'Which session and/or oral presentation under 3a: CARPHA Innovations in Public Health was the most outstanding?',
      type: 'radio',
      options: [
        "0-01: Advancing public health innovations: Caribbean Public Health Agency (CARPHA)'s novel Caribbean-tailored early warning and response systems and tools for regional health security.",
        "0-02: Unlocking surveillance potential through CARPHA's Novel regional integrated early warning surveillance system.",
        "0-03: CARPHA's Aberration Reporting System: DHIS2-Based web application for syndromic surveillance and timely detection of elevated signals.",
        "0-04: Fiction to Function: CARPHA's novel Caribbean tailored Republic of Tingua Emergency preparedness and outbreak response simulation exercise.",
        "0-05: Setting appropriate syndromic surveillance alert thresholds for mass gathering events in Small Island Developing States (SIDS) in the Caribbean.",
        "0-06: Innovative Expansion of CARPHA's Regional One Health Foodborne and zoonotic diseases program.",
        "0-07: Expanding laboratory capacity in the Caribbean: innovative hub-and-network model for One Health diagnostics, AMR surveillance, and optimised sample transport.",
        "0-08: Establishing regional antimicrobial resistance (AMR) surveillance in the Caribbean supported by Caribbean Antimicrobial Resistance Alliance (CARA)",
        "Not Applicable"
      ]
    },
    {
      no: '7',
      id: '12',
      question:
        'Which session and/or oral presentation under 3b Emerging Research was the most outstanding?',
      type: 'radio',
      options: [
        "0-09: Improving HIV surveillance accuracy through national data cleaning and cohort validation: results of the 2025 HIV treatment e-register review in Guyana.",
        "0-10: Primary care patients' awareness and perceptions towards medicinal cannabis in Barbados.",
        "0-11: An emerging threat; microbiological profiles and antimicrobial susceptibility patterns of carbapenem-resistant Enterobacterales identified at Georgetown Public Hospital Corporation, 2023-2025",
        "0-12: Knowledge and attitudes of registered nurses towards artificial intelligence at a national hospital in Antigua.",
        "0-13: Trends in diabetic ketoacidosis in Guyana: a two-year review of clinical profiles and outcomes at Georgetown Public Hospital Corporation (2023 - 2024)",
        "0-14: Prevalence of overweight, obesity and associated risk factors in Barbadian primary school children.",
        "0-15: Patient confidentiality practices in Grenada: evidence to inform health system innovation.",
        "0-16: Implementing a capacity-based mental health law in Bermuda: International lessons and Caribbean implications.",
        'Not Applicable.'
      ]
    },
    {
      no: '8',
      id: '13',
      question:
        'Which session and/or oral presentation under 4b: Innovation in Healthcare was the most outstanding?',
      type: 'radio',
      options: [
        "0-23: Innovative mobile medical consultations: a scalable public health solution for communities affected by sargassum seaweed.",
        "0-24: Innovating access: evaluating the impact of Telemedicine on healthcare delivery in hinterland regions of Guyana.",
        "0-25: Conceptualisation of a framework that facilitates the pathway from academia to industry.",
        "0-26: Multimodal AI for early Alzheimer's detection: accuracy and optimal combinations.",
        "0-27: Digital health innovation for cancer prevention and support insights from the Caribbean Cancer Portal",
        'Not Applicable.'
      ]
    },
    {
      no: '9',
      id: '14',
      question:
        'Which session and/or oral presentation under 4a: Climate Change/Surveillance was the most outstanding?',
      type: 'radio',
      options: [
        "0-17: Methodologies for assessing water sanitation and hygiene resilience in climate-vulnerable primary care facilities: a critical review for Guyana.",
        "0-18: Climate Change, health impacts and adaptation: perspectives of Guyanese healthcare and agricultural professionals (2025)",
        "0-19: Assessment of a Public Health Communication Campaign on Climate Change and Health.",
        "0-20: Hidden threats beneath the surface: antibiotic resistance in pig farm runoff water.",
        "0-21: Establishing the CARPHA integrated antimicrobial resistance (AMR) programme: a regional partnership and On Health Approach.",
        "0-22: From bite to insight: clinical demographic and laboratory predictors of severe outcomes in adult dengue fever patients.",
        'Not Applicable.'
      ]
    },
    {
      no: '10',
      id: '15',
      question: 'Please rate the following aspects of the Poster Presentations',
      type: 'rating-matrix',
      items: [
        { id: '16', label: 'Scientific content' },
        {
          id: '17',
          label: 'Clarity of presentation [if video was viewed/accessible]'
        },
        { id: '18', label: 'Visual impact' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },
    {
      no: '11',
      id: '19',
      question:
        'Please select a rating for the following aspects of the event facilities:',
      type: 'rating-matrix',
      items: [
        { id: '20', label: 'Secretariat support' },
        {
          id: '21',
          label:
            'Physical venue: ease of accessing location and organization of lecture & session rooms'
        },
        {
          id: '22',
          label:
            'Engagement at Location: discussions with presenters/exhibitors and other attendees'
        },
        {
          id: '23',
          label: 'Display and presentation of Exhibition Booths at the location'
        },
        { id: '24', label: 'Technical support for participants on location' },
        { id: '25', label: 'Selection and Quality of Food' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },
    {
        no: "12",
        id: "26",
        question: "What were your expectations/goals for attending this Conference? Please rank options below, with 1 as the highest goal and 6 as the lowest?",
        type: "ranking",
        items: [
          { id: "27", label: "Gaining more subject matter expertise or expanding your knowledge and find solutions to problems" },
          { id: "28", label: "Network for future collaborations" },
          { id: "29", label: "Peer discussion of new research for application" },
          { id: "30", label: "To find about out more about public health in the Caribbean region" },
          { id: "31", label: "Improve research skills set" },
          { id: "32", label: "Presentation of a research paper" }
        ],
        originalItems: [
            { id: "27" },
            { id: "28" },
            { id: "29" },
            { id: "30" },
            { id: "31" },
            { id: "32" }
          ]
      },
    {
      no: '13',
      id: '33',
      question:
        'Where there any standout moments or experiences during the conference?',
      type: 'textarea'
    },
    {
      no: '14',
      id: '34',
      question:
        'On a scale of 1 to 10, how likely are you to recommend the CARPHA Conference to a friend or colleague?',
      type: 'rating',
      scale: 10
    },
    {
      no: '15',
      id: '35',
      question:
        'Please state below any general comments or suggestions for improvement in the future.',
      type: 'textarea'
    },
    {
      no: '16',
      id: '36',
      question: 'CME Credits - Day 1 Only (April 22, 2026) - 6.50 Credits',
      type: 'radio',
      options: ['Apply Credits', 'Not Required']
    }
  ]);

  const handleChange = (id, value) => {
    setAnswers(prev => ({
      ...prev,
      [id]: value
    }));

    // 🔥 HAPUS ERROR SAAT USER ISI
    setErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[id];
      return newErrors;
    });
  };

  const handleSubmit = () => {
    if (!validate()) {
        alert("Please complete all questions first");
        return;
      }

      let survey = [];

      // 🔹 normal answers
      Object.keys(answers).forEach(key => {
        survey.push({
          id_question: key,
          answer: answers[key]
        });
      });

      // 🔥 ranking answers (INI YANG KAMU MAU)
      questions.forEach(q => {
        if (q.type === "ranking") {
            q.items.forEach((item, index) => {
                survey.push({
                  id_question: q.originalItems[index].id, // 🔥 ID tetap
                  answer: item.label                      // 🔥 label geser
                });
              });
        }
      });



    const payload = {
      id_user: props?.user?.id_user,
      day: 1,
      json: JSON.stringify({
        survey : survey
      })
    };





      var form_data = new FormData();

      for (var key in payload) {
        form_data.append(key, payload[key]);
      }

      setLoading(true);

      axios
        .post(CONFIG.URL + '/survey/submit', form_data, {
          headers: {
            token: CONFIG.TOKEN_SURVEY
          }
        })
        .then(function (response) {
          setLoading(false);
          if (response?.data?.status === 'SUCCESS') {
props.onSuccess()
          } else {
          }
        })
        .catch(function (error) {});

  };

  return (
    <div className="w-full mx-auto space-y-2">

      <div className="w-full bg-white">
      <hr className='my-2'/>
      <div className="text-black flex flex-col font-bold my-2 text-2xl text-center">
                <span className="text-4xl"> {props?.user?.name}</span>
                <span className="text-lg text-black mt-2">
                  {props?.user?.position}
                </span>
                <span className="text-lg text-black mt-2">{props?.user?.company}</span>

              </div>

              <hr className='my-2'/>

        {/* TOP TITLE BAR */}
        <div className="bg-slate-600 text-white text-center py-6 px-4">
          <h1 className="text-xl md:text-2xl font-bold tracking-wide">
            CARPHA 70TH ANNUAL HEALTH RESEARCH CONFERENCE
          </h1>
          <p className="text-lg md:text-xl font-semibold mt-1">
            EVALUATION FORM – Day 1
          </p>
        </div>

        {/* CONTENT */}
        <div className="max-w-4xl mx-auto px-6 py-8 space-y-6">
          <h2 className="text-xl font-bold">
            Welcome to the CARPHA 70TH Annual Health Research Conference
            Evaluation
          </h2>

          <p className="text-gray-700 leading-relaxed">
            Please share your conference experience by completing this survey.
            Your feedback is important to assist with improving our Annual
            Health Research Conference. All your responses are anonymous and
            confidential as CARPHA would not be collecting any personal
            information. If you click the survey link, you are stating that you
            understand that your participation in this survey is completely
            voluntary.
          </p>
        </div>
      </div>

      {questions.map((q) => {
        const hasMatrixError =
        q.type === "rating-matrix" &&
        q.items.some(item => errors[item.id]);

        return ( <div
          id={`question-${q.id}`}
            key={q.id}
             className={`p-4 border rounded-xl shadow-sm ${
        errors[q.id] || hasMatrixError
          ? "border-red-500"
          : "border-gray-200"
      }`}>
            <p className="font-semibold mb-3">
              {q.no}. {q.question}
            </p>

            {/* RADIO */}
            {q.type === 'radio' && (
              <div className="flex flex-wrap gap-2">
                {q.options.map((opt) => {
                  const isSelected = answers[q.id] === opt;

                  return (
                    <button
                      key={opt}
                      type="button"
                      onClick={() => handleChange(q.id, opt)}
                      className={`
              px-4 py-2 rounded-lg border text-sm transition text-left
              ${
                isSelected
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-white hover:bg-blue-50 border-gray-300'
              }
            `}>
                      {opt}
                    </button>
                  );
                })}

                {/* OTHER INPUT */}
                {q.hasOther && (
                  <input
                    type="text"
                    placeholder="Other..."
                    className="w-full border p-2 rounded mt-2"
                    onChange={(e) => handleChange(q.id, e.target.value)}
                  />
                )}
              </div>
            )}

{q.type === "ranking" && (
  <div className="space-y-2">
    {q.items.map((item, index) => (
      <div
        key={item.id}
        className="flex items-center justify-between border p-2 rounded"
      >
        <span className="text-sm">
          {index + 1}. {item.label}
        </span>

        <div className="flex gap-2">
          <button
            type="button"
            disabled={index === 0}
            onClick={() => moveUp(q.id, index)}
            className="px-2 border rounded"
          >
            ↑
          </button>

          <button
            type="button"
            disabled={index === q.items.length - 1}
            onClick={() => moveDown(q.id, index)}
            className="px-2 border rounded"
          >
            ↓
          </button>
        </div>
      </div>
    ))}
  </div>
)}

            {/* TEXTAREA */}
            {q.type === 'textarea' && (
              <textarea
                className="w-full border p-2 rounded"
                rows="3"
                onChange={(e) => handleChange(q.id, e.target.value)}
              />
            )}

            {/* RATING 1-10 */}
            {q.type === 'rating' && (
              <div className="space-y-2">
                {/* Label kiri kanan */}
                <div className="flex justify-between text-xs text-gray-500">
                  <span>Not at all likely</span>
                  <span>Extremely likely</span>
                </div>

                {/* Button rating */}
                <div className="flex w-full gap-2">
                  {Array.from({ length: q.scale }, (_, i) => i + 1).map((num) => {
                    const isActive = answers[q.id] === num;

                    return (
                      <button
                        key={num}
                        type="button"
                        onClick={() => handleChange(q.id, num)}
                        className={`
                 h-10 rounded-lg border text-sm font-medium w-full
                transition-all duration-150
                ${
                  isActive
                    ? 'bg-blue-600 text-white border-blue-600 scale-110 shadow'
                    : 'bg-white border-gray-300 hover:bg-blue-50'
                }
              `}>
                        {num}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {q.type === 'rating-matrix' && (
              <div className="space-y-4">
                {q.items.map((item) => {
                  const selected = answers[item.id];

                  return (
                    <div id={`question-${item.id}`} key={item.id}>
                      <p className="text-sm font-medium mb-2">{item.label}</p>

                      <div className="flex w-full gap-2">
                        {q.scale.map((scale) => {
                          const isActive = selected === scale;

                          return (
                            <button
                              key={scale}
                              type="button"
                              onClick={() => handleChange(item.id, scale)}
                              className={`w-full
                      px-3 py-1.5 text-xs rounded-lg border transition
                      ${
                        isActive
                          ? 'bg-blue-600 text-white border-blue-600'
                          : 'bg-white border-gray-300 hover:bg-blue-50'
                      }
                    `}>
                              {scale}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

{(errors[q.id] || hasMatrixError) && (
  <p className="text-red-500 text-sm mt-2">
   This field is required
  </p>
)}
          </div>)
      }



      )


      }

       <div className='flex w-full gap-4'>
        <button
          onClick={() => props.handleCancel()}
          className="bg-red-600 text-white px-4 py-2 rounded w-max">
          Cancel
        </button>
        <button
        disabled={loading}
        onClick={handleSubmit}
        className="bg-blue-600 text-white px-4 py-2 rounded w-full">
        {loading ? "Submitting..." : "Submit Survey"}
      </button>
      </div>
    </div>
  );
}
